import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { AuthUser } from '../../core/auth/auth-frame/auth-user.model';
import { AuthService } from '../../core/auth/auth.service';
import { UserProfile } from './user-profile.model';

@Injectable({
  providedIn: 'root'
})

export class InfoProfileService {

  private userInfo: UserProfile;
  private userSubject: BehaviorSubject<UserProfile> = new BehaviorSubject<UserProfile>(null);

  constructor(private authService: AuthService) {
  }

  getUserProfile(): Observable<UserProfile> {
    if (!this.userInfo)
      this.retrieveUserInformation();

    return this.userSubject.asObservable();
  }

  private retrieveUserInformation(): void {

    this.authService.getAuthModel().subscribe((response: AuthUser) => {

      let userName: string;
      let userPicture: string;

      if (response) {

          userName = response.name;

          if (!response.picture || response.picture == "") {
            response.picture = "./assets/img/user_placeholder.PNG";
          }
          userPicture = response.picture;
          this.userInfo = new UserProfile(userName, userPicture);
          this.userSubject.next(this.userInfo);
      }
    }, (error) => {
      console.log(error)
    });
  }
}
